import { Stack } from "expo-router";

export default function DrawerLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="start/index" />
      <Stack.Screen name="stock/index" />
      <Stack.Screen name="addproduct/index" />
      <Stack.Screen name="scanner/index" />
      <Stack.Screen name="scannerwithout/index" />
      <Stack.Screen name="bills/index" />
      <Stack.Screen name="statistics/index" />
      <Stack.Screen name="dettes/index" />
      <Stack.Screen name="dettes/add-dette/index" />
      <Stack.Screen name="dettes/[id]" />
      <Stack.Screen name="orders/index" />
      <Stack.Screen name="notifications/index" />
      <Stack.Screen name="params/index" />
      <Stack.Screen name="params/profile/index" />
      <Stack.Screen name="params/profile/change-password" />
      <Stack.Screen name="params/contact/index" />
      <Stack.Screen name="params/limits/index" />
      <Stack.Screen name="params/store-info/index" />
      <Stack.Screen name="params/update/index" />
    </Stack>
  );
}
